<div class="page-container" *ngIf="selectedShipyard">
    <div class="builder-title">
        <mat-icon svgIcon="folder" class="shipyard-icon" />
        <div data-cy="shipyard-folder-title" class="link-title">
            {{ selectedShipyard.name }}
        </div>
    </div>
    <div style="display: flex; justify-content: flex-end">
        <div data-cy="shipyard-folder-new-vessel-button" class="new-vessel button" (click)="createVessel()">
            <mat-icon svgIcon="vessel-folder" class="options-icon" />
            {{ 'recent.button.new-vessel' | translate }}
        </div>
        <div
            data-cy="shipyard-folder-more-options-button"
            class="button"
            (click)="openMoreOptions(); $event.stopPropagation()">
            <mat-icon svgIcon="more-options" class="options-icon" />
        </div>

        <div *ngIf="showOtherOptions" style="position: relative; align-self: end">
            <div class="more-options-container" #otherOptions>
                <div
                    data-cy="shipyard-folder-more-options-edit-button"
                    class="button extra-option"
                    (click)="editShipyard()">
                    <mat-icon svgIcon="edit-pen" class="options-icon" />
                    {{ 'shipyard.page.button.edit.vessel' | translate }}
                </div>
                <div
                    data-cy="shipyard-folder-more-options-delete-button"
                    class="button extra-option"
                    (click)="deleteShipyard()">
                    <mat-icon svgIcon="delete" class="options-icon" />
                    {{ 'shipyard.page.button.delete.vessel' | translate }}
                </div>

                <div
                    data-cy="shipyard-folder-more-options-duplicate-button"
                    class="button extra-option"
                    (click)="duplicateShipyard()">
                    <mat-icon svgIcon="duplicate" class="options-icon" />
                    {{ 'shipyard.page.button.duplicate.vessel' | translate }}
                </div>
            </div>
        </div>
    </div>
    <div class="top">
        <div class="vessels-label" data-cy="shipyard-folder-vessel-section-header">
            {{ 'shipyard.vessels.title' | translate }}
        </div>
        <div class="icons-container">
            <mat-icon
                data-cy="shipyard-folder-card-view-icon"
                svgIcon="grid"
                class="icon"
                [ngClass]="{ icon_active: displayGridView }"
                (click)="viewModeToggle(true)" />
            <mat-icon
                data-cy="shipyard-folder-list-view-icon"
                svgIcon="list"
                class="icon"
                [ngClass]="{ icon_active: !displayGridView }"
                (click)="viewModeToggle(false)" />
        </div>
    </div>
    <div *ngIf="displayGridView" class="vessel-grid" data-cy="shipyard-folder-vessels-section-grid">
        <ng-container *ngFor="let vessel of selectedShipyard.vessels">
            <app-vessel-information-grid
                [vessel]="vessel"
                [shipyardName]="selectedShipyard.name"
                [vesselEditors]="vesselsEditors[vessel.id]"></app-vessel-information-grid>
        </ng-container>
    </div>
    <div div *ngIf="!displayGridView" class="vessel-list" data-cy="shipyard-folder-vessels-section-list">
        <ng-container *ngFor="let vessel of selectedShipyard.vessels">
            <app-vessel-information-list
                [vessel]="vessel"
                [shipyardName]="selectedShipyard.name"
                [vesselEditors]="vesselsEditors[vessel.id]"></app-vessel-information-list>
        </ng-container>
    </div>
</div>

<ng-container *ngIf="isLoading"> <app-loading-spinner class="spinner-loading"></app-loading-spinner></ng-container>
